module.exports = __webpack_public_path__ + "img/canbadge_triangle_w70mm_trimmark.d9f12589.png";